import logger from '@/logger';
import { notification } from 'antd';

export const socketErrorMessage = error => error?.message ?? '';

const showError = description => notification.error({ message: 'Error', description });

// eca-websockets reports the unexpected errors to Sentry and skips 401s and rejections users are shown, so here it's only a breadcrumb.
export const logSocketError = (error, context) =>
	logger.warn(error?.message ?? 'Socket request failed', context);

const context = { location: 'wsHelpers.displayMessage', message: 'WS server error' };

const logFailure = error => {
	if (!(error instanceof Error)) logSocketError(error, context);
	else if (!error.disconnected) logger.error(error, context);
};

export const displayMessage = (description, error) => {
	if (!error) return notification.success({ message: 'Success', description });
	showError(description);
	logFailure(error);
};

export const SILENT_EVENT_UPDATE = 'silent';

export const createEventErrorMessage = error => {
	if (error?.disconnected) {
		return 'Lost connection to the server, so the event was not created. Wait a moment and try again.';
	}
	if (error?.timedOut) {
		return "The server didn't respond, so the event may not have been created. Refresh the page to check before trying again.";
	}
	if (socketErrorMessage(error).includes('unpaid events'))
		return 'You cannot create more than two unpaid events';
	return 'Event could not be created';
};

export const displayCreateEventError = error =>
	displayMessage(createEventErrorMessage(error), error);
